import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { PrismicDocument } from '@prismicio/client';
import { switchMap } from 'rxjs';
import { BreadcrumbsComponent } from 'breadcrumbs';
import { LanguageService } from 'language';
import { ArticlesListComponent } from '../articles-list/articles-list.component';
import { CategoriesListComponent } from '../categories-list/categories-list.component';
import { CategoryService } from '../category.service';
import { SupportCategory } from '../support-types';

@Component({
  selector: 'app-category-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BreadcrumbsComponent, CategoriesListComponent, ArticlesListComponent],
  templateUrl: './category-page.component.html',
})
export class CategoryPageComponent {
  private route = inject(ActivatedRoute);
  public readonly category = input<PrismicDocument<SupportCategory>>();
  private categoryService = inject(CategoryService);
  public languageService = inject(LanguageService);
  public categoryChain = toSignal(
    toObservable(this.category).pipe(
      switchMap(categoryDoc => this.categoryService.getCategoryChain(categoryDoc.data.parent?.id))
    )
  );
}
